import rootStore from '@vue-storefront/core/store';

export const locationRoute = (path) => {
  const currentLocation = rootStore.getters['locations/getActiveLocation'];

  if (currentLocation && currentLocation.code) {
    // Leading slash matters: without it this is a relative router-link target
    // (resolves against the current route) instead of an absolute one from
    // the site root - see Logo.vue/Breadcrumbs.vue for the same pattern.
    return `/${currentLocation.code}${path}`;
  }

  // K2-2716: routes built from this helper require a :locationCode segment
  // (e.g. '/:locationCode/about-courier') - the bare `path` on its own can
  // never match once there's no active location, so it's not a safe
  // fallback. Fall back to the site root instead, same as Logo.vue does
  // when there's no active location.
  return '/';
};
